/**
 * HashRouter paths for public telephony report shares.
 * URLs must be `origin/#/public/reports/...` (not `/public/reports/...` without hash).
 */

/** @param {string} token */
export function buildPublicReportHashPath(token, query = {}) {
	const params = new URLSearchParams();
	Object.entries(query).forEach(([key, value]) => {
		if (value != null && value !== '') {
			params.set(key, String(value));
		}
	});
	const qs = params.toString();
	return `/#/public/reports/${token}${qs ? `?${qs}` : ''}`;
}

/**
 * @param {string} [origin] — defaults to window.location.origin
 * @param {string} token
 * @param {Record<string, string>} [query]
 */
export function buildPublicReportShareUrl(token, query = {}, origin) {
	const base = (origin || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/$/, '');
	return `${base}${buildPublicReportHashPath(token, query)}`;
}

/** @param {string} [pathname] */
export function isPublicReportPath(pathname) {
	return typeof pathname === 'string' && pathname.startsWith('/public/reports');
}

/** Ensures HashRouter-compatible share URLs for links created before the #/ fix. */
export function normalizePublicReportShareUrl(url) {
	if (!url || typeof url !== 'string') return url;
	if (url.includes('/#/public/reports/')) return url;
	return url.replace('/public/reports/', '/#/public/reports/');
}
